module.exports = __webpack_public_path__ + "img/IMG_1219.1f07e787.jpg";